export default {
  components: {
    linkCard: 'dt.manageContest.components.linkCard',
  },
};
